import {
  CircularProgress,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
  withStyles,
} from "@material-ui/core";

export const CustomMenu = withStyles({
  paper: {
    borderRadius: 8,
  },
})(Menu);

export const CustomListItem = withStyles({
  root: {
    color: "#354454",
    height: 48,
  },
})(MenuItem) as typeof MenuItem;

export const CustomListItemIcon = withStyles({
  root: {
    color: "#354454",
    fontSize: 20,
    minWidth: 32,
  },
})(ListItemIcon);

export const CustomListItemText = withStyles({
  root: {
    // color: "#354454",
    fontSize: 14,
  },
})(Typography);

export const Loader = ({
  fullScreen,
  message,
}: {
  fullScreen?: boolean;
  message?: string;
}) => {
  return fullScreen ? (
    <div className="absolute top-0 bottom-0 left-0 right-0 z-10 flex items-center justify-center bg-white/80">
      <div className="m-auto p-10 text-center">
        <CircularProgress color="inherit" size={20} />
        {message && <p>{message}</p>}
      </div>
    </div>
  ) : (
    <div className="inline-flex items-center">
      <CircularProgress color="inherit" size={20} />
      {message && <span className="ml-1">{message}</span>}
    </div>
  );
};
